import { Route } from 'react-router-dom'
import { URLS } from './constants'
import { PrivateRoute } from 'components/utils/PrivateRoute'
import { ValidateCoupon } from './ValidateCoupon'

export const useCoraSGRRoutes = applicationPages => {
  return (
    <>
      <Route
        path={URLS.AUTH_CORA_VALIDATE_COUPON}
        element={<PrivateRoute component={ValidateCoupon} applicationPages={applicationPages} />}
      />
    </>
  )
}
